import React, { useRef } from 'react';
import { CourseShowView } from '../../../../types/courses';
import './courseHeader.module.scss';
import { observer } from 'mobx-react';
import { ImageApis } from '../../../../../commonv3/api/images';
import { PracticalExamCompleteRibbon, WritingExamCompleteRibbon } from '../Ribbon';
import { observable, makeObservable } from 'mobx';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';
import classNames from 'classnames';
import { useSpring, animated } from 'react-spring';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import useComponentSize from '@rehooks/component-size';

type ShowCourseCompleteRibbon = {
  completedWritingCount: number;
  completedPracticalCount: number;
  courseExamWritingCount: number;
};

const OverviewBody = ({ overview, refCallback = undefined }) => (
  <div styleName="overview-body" dangerouslySetInnerHTML={{ __html: overview }} ref={refCallback} />
);

const OverviewContainer = ({ expanded, overview, refCallBack }) => {
  const ref = useRef(null);
  const { height } = useComponentSize(ref);
  const style = useSpring({ maxHeight: expanded ? height : 250 });
  return (
    <animated.div styleName={classNames('overview-container', { expanded: expanded })} style={style}>
      <OverviewBody
        overview={overview}
        refCallback={(r) => {
          ref.current = r;
          refCallBack();
        }}
      />
      <div styleName="gradient" />
    </animated.div>
  );
};

const ShowCourseCompleteRibbon = ({
  completedWritingCount,
  completedPracticalCount,
  courseExamWritingCount,
}: ShowCourseCompleteRibbon) => (
  <div styleName="title-ribbon">
    {completedWritingCount !== 0 && courseExamWritingCount === completedWritingCount && (
      <WritingExamCompleteRibbon styleName="ribbon-image" />
    )}
    {completedPracticalCount !== 0 && <PracticalExamCompleteRibbon styleName="ribbon-image" />}
  </div>
);

type Props = {
  course: CourseShowView;
};

export const CourseHeader = observer(
  class CourseHeader extends React.Component<Props> {
    showMore = true;
    expanded = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    overviewHeight: any = 100;

    expandOverview = () => {
      this.expanded = !this.expanded;
    };

    hideShowMore = (element) => {
      if (element && element.getBoundingClientRect().height < 200) {
        this.expanded = true;
        this.showMore = false;
      }
    };

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        showMore: observable,
        expanded: observable,
        overviewHeight: observable,
      });
    }

    imageUrl() {
      const { course } = this.props;
      return GlobalStatesV3.viewport.isMobile
        ? ImageApis.getUrlFor(course.detail_eyecatch_sp)
        : ImageApis.getUrlFor(course.detail_eyecatch);
    }

    render() {
      const { course } = this.props;

      return (
        <>
          <div styleName="header">
            <div styleName="main">
              <div styleName="lesson-count">全{course.lesson_count}レッスン</div>
              <div styleName="title">
                <ShowCourseCompleteRibbon
                  completedWritingCount={course.completed_writing_count}
                  completedPracticalCount={course.completed_practical_count}
                  courseExamWritingCount={course.writing_exam_count}
                />
                {course.title}
              </div>
              <div styleName="overview-wrapper">
                <OverviewContainer
                  expanded={this.expanded}
                  overview={course.overview}
                  refCallBack={this.hideShowMore}
                />
                <div
                  styleName={classNames('expand-button', { hidden: !this.showMore || this.expanded })}
                  onClick={this.expandOverview}
                >
                  もっと見る
                </div>
              </div>
            </div>
            <div styleName="thumbnail-wrapper">
              <img styleName="thumbnail" src={this.imageUrl()} />
            </div>
          </div>
          <div styleName="overview-wrapper">
            <div styleName="overview-header">
              <BrushedLabel>概要</BrushedLabel>
            </div>
            <OverviewBody overview={course.overview} />
          </div>
        </>
      );
    }
  }
);
